import React from 'react';
import './forms.css';

const ComodityBuy = () => {
    return (
        <div className="forms">
            <iframe
                src="https://docs.google.com/forms/d/e/1FAIpQLSdyf2368dz58_ISjiE_c84VWDuZGUliRT_7B4-zDfjJ5F6XhA/viewform?embedded=true"
                width="100%" /* Set the iframe width to 100% */
                height="100%" /* Allow the height to adapt to the container */
                frameBorder="0"
                title="General Delegate Form"
            >
                Loading…
            </iframe>
        </div>
    );
}

export default ComodityBuy;
